export default "__VITE_ASSET__C9LDl0mS__"